var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "f7-list",
        {
          staticClass: "itemList",
          staticStyle: { "font-size": "16px" },
          attrs: { "accordion-list": "" },
        },
        _vm._l(_vm.projectsInformation, function (project, index) {
          return _c(
            "f7-accordion-item",
            {
              key: project.IdGroup,
              staticClass: "accordionForm",
              attrs: { expanded: false },
              on: {
                "accordion:open": function ($event) {
                  return _vm.getInvoices(index)
                },
              },
            },
            [
              _c("f7-accordion-toggle", { staticClass: "accordionToggle" }, [
                _c("ul", [
                  _c("li", { staticClass: "swipeout" }, [
                    _c("div", { staticClass: "swipeout-content" }, [
                      _c("div", { staticClass: "item-content boxRequest" }, [
                        _c("div", { staticClass: "item-media" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-inner" }, [
                          _c("table", { attrs: { width: "100%" } }, [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    width: "45%",
                                    "min-width": "45%",
                                    "max-width": "45%",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(project.Name) +
                                      "\n                        "
                                  ),
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "statusLabel showLargeScreenOnly",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t(
                                                "common.status.status_label"
                                              ) +
                                                ": " +
                                                _vm.getStatusLabel(
                                                  project.Status
                                                )
                                            ) +
                                            "\n                          "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "showSmallScreenOnly" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "item-subtitle showSmallScreenOnly",
                                          staticStyle: {
                                            "white-space": "normal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$t("common.amnt") +
                                                  ": " +
                                                  project.Amount +
                                                  " €"
                                              ) +
                                              "\n                          "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "showSmallScreenOnly" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "statusLabel" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.status.status_label"
                                                ) +
                                                  ": " +
                                                  project.Status
                                              ) +
                                              "\n                          "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "showLargeScreenOnly",
                                  staticStyle: {
                                    width: "45%",
                                    "min-width": "45%",
                                    "max-width": "45%",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("common.amnt") +
                                          ": " +
                                          project.Amount +
                                          " €"
                                      ) +
                                      "\n                      "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", {
                                staticClass: "showLargeScreenOnly",
                                staticStyle: {
                                  width: "25%",
                                  "min-width": "25%",
                                  "max-width": "25%",
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "f7-accordion-content",
                [
                  _vm.projects[index] === undefined ||
                  _vm.projects[index].Invoices === undefined
                    ? _c("spinner")
                    : _vm.projects[index].Invoices.length > 0
                    ? _c("invoices-list", {
                        attrs: {
                          filterBy: false,
                          invoices: _vm.projects[index].Invoices,
                          showInvoiceMainDetails: false,
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            background: "#dcdcdc",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.no_invoice_yet")) +
                              "\n        "
                          ),
                        ]
                      ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }